import { render, staticRenderFns } from "./shengyibefor.vue?vue&type=template&id=47691a84&scoped=true&"
import script from "./shengyibefor.vue?vue&type=script&lang=js&"
export * from "./shengyibefor.vue?vue&type=script&lang=js&"
import style0 from "./shengyibefor.vue?vue&type=style&index=0&id=47691a84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47691a84",
  null
  
)

export default component.exports